import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../services/api';
import BottomNav from '../components/BottomNav';
import logo from '../assets/logo.png'; // Make sure the logo exists in /src/assets
import bannerDesktop from '../assets/banner-desktop.png';
import btcIcon from '../assets/coins/btc.png';
import ethIcon from '../assets/coins/eth.png';
import usdtIcon from '../assets/coins/usdt.png';
// import bnbIcon from '../assets/coins/bnb.png';
// import xrpIcon from '../assets/coins/xrp.png';
// import adaIcon from '../assets/coins/ada.png';
// import solIcon from '../assets/coins/sol.png';
// import dogeIcon from '../assets/coins/doge.png';
// import dotIcon from '../assets/coins/dot.png';
// import ltcIcon from '../assets/coins/ltc.png';
// import maticIcon from '../assets/coins/matic.png';
// import trxIcon from '../assets/coins/trx.png';
// import avaxIcon from '../assets/coins/avax.png';
// import linkIcon from '../assets/coins/link.png';
// import etcIcon from '../assets/coins/etc.png';
// import xlmIcon from '../assets/coins/xlm.png';

const coinIcons = {
  BTC: btcIcon,
  ETH: ethIcon,
  USDT: usdtIcon,
  // Add more mappings as needed
};

// const marketData = [
//     { symbol: 'BTC/USDT', price: 105264.07, change: 0.36, icon: btcIcon },
//     { symbol: 'ETH/USDT', price: 3567.22, change: 1.22, icon: ethIcon },
//     { symbol: 'BNB/USDT', price: 412.45, change: 0.45, icon: bnbIcon },
//     { symbol: 'XRP/USDT', price: 0.65, change: -0.32, icon: xrpIcon },
//     { symbol: 'ADA/USDT', price: 0.49, change: 2.03, icon: adaIcon },
//     { symbol: 'SOL/USDT', price: 134.02, change: 0.87, icon: solIcon },
//     { symbol: 'DOGE/USDT', price: 0.072, change: 1.76, icon: dogeIcon },
//     { symbol: 'DOT/USDT', price: 6.03, change: 0.95, icon: dotIcon },
//     { symbol: 'LTC/USDT', price: 92.13, change: 0.23, icon: ltcIcon },
//     { symbol: 'TRX/USDT', price: 0.13, change: 0.12, icon: trxIcon },
//     { symbol: 'AVAX/USDT', price: 13.04, change: -1.03, icon: avaxIcon },
//     { symbol: 'LINK/USDT', price: 14.67, change: -0.21, icon: linkIcon },
//     { symbol: 'ETC/USDT', price: 23.36, change: 1.10, icon: etcIcon },
//     { symbol: 'MATIC/USDT', price: 0.73, change: -0.54, icon: maticIcon },
//     { symbol: 'XLM/USDT', price: 0.10, change: 0.49, icon: xlmIcon },
//   ];

const UserHome = () => {
  const [activePopup, setActivePopup] = useState(null);
  const [marketData, setMarketData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const fullEmail = localStorage.getItem('userEmail') || 'user@example.com';
  const userName = fullEmail.split('@')[0]; // take part before @

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await api.get('/api/trading/prices');

        // Check if data is directly in response.data.data (array) or nested in prices
        const prices = Array.isArray(response.data?.data)
          ? response.data.data
          : response.data?.data?.prices || [];

        // Transform API data to match UI format
        const formattedData = prices.map((coin) => ({
          symbol: `${coin.symbol}/USDT`,
          price: coin.currentPrice,
          change: coin.priceChange24h,
          icon: coin.icon || coinIcons[coin.symbol] || btcIcon,
          name: coin.name,
        }));

        setMarketData(formattedData);
      } catch (error) {
        toast.error('Failed to load market prices', {
          position: 'bottom-left',
          autoClose: 3000,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
    // Refresh prices every 30 seconds
    const interval = setInterval(fetchPrices, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ paddingTop: '20px', paddingBottom: '100px' }}>
      <Container
        fluid
        style={{
          maxWidth: isMobile ? '100%' : '85%',
          padding: 'clamp(1rem, 3vw, 1.5rem)',
          backgroundColor: '#FFFFFF',
          minHeight: '100vh',
        }}
      >
        {/* Header */}
        <Row className='align-items-center justify-content-between mb-3'>
          {/* Language flag on the left */}
          <Col xs='auto'>
            <img src='https://flagcdn.com/w40/us.png' alt='EN' width='28' />
          </Col>

          {/* Email first, then logo on the right */}
          <Col
            className='d-flex justify-content-end align-items-center gap-2'
            xs='auto'
          >
            <strong style={{ fontSize: '0.95rem' }}>{userName}</strong>
            <Link to='/profile'>
              <img
                src={logo}
                alt='Rain Logo'
                height={28}
                style={{ cursor: 'pointer' }}
              />
            </Link>
          </Col>
        </Row>

        {/* Banner */}
        <Row className='mb-3 mx-0'>
          <Col className='px-0'>
            <div
              className='position-relative'
              style={{
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
                width: '100%',
                height: 'auto',
              }}
            >
              <img
                src={bannerDesktop}
                alt='Banner'
                // className='w-100 d-block'
                className='position-relative'
                style={{
                  height: 'auto',
                  objectFit: 'cover',
                  width: '100%',
                  maxHeight: '540px',
                }}
              />
            </div>
          </Col>
        </Row>

        {/* Notice */}
        <Row className='mb-3'>
          <Col>
            <div
              className='bg-light border rounded-pill d-flex align-items-center px-3 py-1'
              style={{
                overflow: 'hidden',
                position: 'relative',
                height: '40px',
              }}
            >
              {/* Fixed Icon on Left */}
              <div
                style={{
                  flexShrink: 0,
                  width: '40px',
                  textAlign: 'center',
                  fontSize: '1.1rem',
                  zIndex: 2,
                }}
              >
                🔊
              </div>

              {/* Scrolling Text Area */}
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    display: 'inline-block',
                    whiteSpace: 'nowrap',
                    paddingLeft: '100%',
                    animation: 'scroll-left 12s linear infinite',
                  }}
                >
                  Welcome to Rain — Your trusted platform for secure crypto
                  investment opportunities. 🌎 Trade smart. Trade safe.
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Quick Actions */}
        <Row className='text-center mb-4 justify-content-center'>
          <Col xs='3'>
            <Link to='/mining' className='text-decoration-none text-dark'>
              <div className='bg-white rounded-circle shadow-sm p-3 mb-2'>
                <i
                  className='bi bi-lock'
                  style={{ fontSize: '1rem', color: '#4e73df' }}
                ></i>
              </div>
              <div style={{ fontSize: '0.85rem' }}>Mining</div>
            </Link>
          </Col>

          <Col xs='3'>
            <Link
              to='/exchangeassets'
              className='text-decoration-none text-dark'
            >
              <div className='bg-white rounded-circle shadow-sm p-3 mb-2'>
                <i
                  className='bi bi-arrow-left-right'
                  style={{ fontSize: '1rem', color: '#36b9cc' }}
                ></i>
              </div>
              <div style={{ fontSize: '0.85rem' }}>Exchange</div>
            </Link>
          </Col>

          <Col xs='3'>
            <Link
              to='/online-service'
              className='text-decoration-none text-dark'
            >
              <div className='bg-white rounded-circle shadow-sm p-3 mb-2'>
                <i
                  className='bi bi-headset'
                  style={{ fontSize: '1rem', color: '#f6c23e' }}
                ></i>
              </div>
              <div style={{ fontSize: '0.85rem' }}>Service</div>
            </Link>
          </Col>

          <Col xs='3'>
            <Link to='/profile' className='text-decoration-none text-dark'>
              <div className='bg-white rounded-circle shadow-sm p-3 mb-2'>
                <i
                  className='bi bi-three-dots'
                  style={{ fontSize: '1rem', color: '#858796' }}
                ></i>
              </div>
              <div style={{ fontSize: '0.85rem' }}>More</div>
            </Link>
          </Col>
        </Row>

        {/* Market List */}
        <Row className='g-2' style={{ marginBottom: '80px' }}>
          {loading ? (
            <Col xs={12} className='text-center py-5'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </Col>
          ) : marketData.length === 0 ? (
            <Col xs={12} className='text-center py-4'>
              <p className='text-muted'>No market data available</p>
            </Col>
          ) : (
            marketData.map((coin, index) => (
              <Col xs={12} key={index} className='position-relative'>
                <div
                  className='bg-white rounded shadow p-2 d-flex justify-content-between align-items-center'
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    setActivePopup(activePopup === index ? null : index)
                  }
                >
                  <div className='d-flex align-items-center gap-2'>
                    <img
                      src={coin.icon}
                      alt={coin.symbol}
                      width={32}
                      height={32}
                      className='coin-icon me-2'
                    />
                    <div>
                      <strong>{coin.symbol}</strong>
                      <div className='text-muted small'>
                        {coin.price.toLocaleString()}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`fw-semibold ${
                      coin.change >= 0 ? 'text-success' : 'text-danger'
                    }`}
                  >
                    {coin.change > 0 ? '+' : ''}
                    {coin.change.toFixed(2)}%
                  </div>
                </div>

                {/* Popup */}
                {activePopup === index && (
                  <div
                    className='position-absolute top-0 end-0 bg-white p-3 rounded shadow-lg'
                    style={{
                      width: '170px',
                      zIndex: 1100,
                      borderRadius: '12px',
                      border: '1px solid #e0e0e0',
                    }}
                  >
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                      <strong className='small' style={{ color: '#333' }}>
                        {coin.symbol}
                      </strong>
                      <button
                        className='btn btn-sm p-0'
                        onClick={(e) => {
                          e.stopPropagation();
                          setActivePopup(null);
                        }}
                        style={{
                          fontSize: '1.5rem',
                          lineHeight: '1',
                          color: '#999',
                        }}
                      >
                        ×
                      </button>
                    </div>
                    <div
                      className='text-muted small mb-3'
                      style={{ fontSize: '0.8rem' }}
                    >
                      Price: ${coin.price.toLocaleString()}
                    </div>

                    <Link to='/option' className='text-decoration-none'>
                      <button
                        className='btn btn-sm w-100 mb-2'
                        style={{
                          background:
                            'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '8px',
                          fontWeight: '600',
                          fontSize: '0.85rem',
                        }}
                      >
                        Option
                      </button>
                    </Link>

                    <Link to='/exchange' className='text-decoration-none'>
                      <button
                        className='btn btn-outline-secondary btn-sm w-100'
                        style={{
                          borderRadius: '8px',
                          padding: '8px',
                          fontWeight: '600',
                          fontSize: '0.85rem',
                        }}
                      >
                        Exchange
                      </button>
                    </Link>
                  </div>
                )}
              </Col>
            ))
          )}
        </Row>

        {/* Bottom Navigation */}
        <BottomNav />
      </Container>
    </div>
  );
};

export default UserHome;
